import reducers from '@/reducers';
import { applyMiddleware, compose, createStore } from 'redux';
import { persistStore } from 'redux-persist';
import ReduxThunk from 'redux-thunk';
import Cache from '@/cache/Cache';
import { createLogger } from 'redux-logger';

const middleware = [ReduxThunk];

if (import.meta.env.NODE_ENV === 'development') {
  const logger = createLogger({ collapsed: true });
  middleware.push(logger);
}

const configureStore = onComplete => {
  const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          trace: true
        })
      : compose;
  const store = createStore(
    reducers,
    {},
    composeEnhancers(applyMiddleware(...middleware))
  );
  const persistor = persistStore(store, null, onComplete);

  return { store, persistor, cache: new Cache() };
};

export default configureStore;
